import { HttpInterceptorFn } from '@angular/common/http';
import { authInterceptor } from './auth.interceptor';
import { http40xInterceptor } from './http40x.interceptor';
import {autoAuthInterceptor} from "./auto-auth.interceptor";

export const HTTP_INTERCEPTORS: Array<HttpInterceptorFn> = [
  authInterceptor,
  autoAuthInterceptor,
  http40xInterceptor,
]